export default __webpack_public_path__ + "static/media/default.11654adc.svg";